<template>
  <div class="sign-in-container" :style="cssVars()">
    <!-- 头部 -->
    <div class="custom-nav-block" :class="[scrollTop ? 'nav-scrolling' : 'nav-default']" :style="`paddingTop:${topBarHeight}px`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="closeWeb">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow02.webp" alt="back" />
          <!-- Sign in bonus -->
          <span class="tit-left">{{ $t('lang.SevenKeepSignin.k011') }}</span>
        </template>
      </van-nav-bar>
    </div>
    <!-- 规则 -->
    <div class="rules" @click="goToRules">{{ $t('lang.BaseCommon.k005') }}</div>
    <!-- 标题 -->
    <div class="sign-in-header">
      <span>{{ $t('lang.SevenKeepSignin.k014') }}</span>
      <span class="dollar-amount">{{ $t('lang.SevenKeepSignin.k015') }}</span>
      <template v-if="$i18n.locale === 'id'">
        <br />
      </template>
      <span>{{ $t('lang.SevenKeepSignin.k016') }}</span>
    </div>
    <!-- 签到内容 -->
    <div class="sign-in-wrapper">
      <!-- 内容 -->
      <div class="sign-in-box">
        <!-- 顶部信息 -->
        <div class="header-wrapper">
          <div class="left">
            <div class="total">{{ $t('lang.BaseCommon.k035') }}</div>
            <div class="coin-wrapper">
              <span>{{ beansAmount }}</span>
              <img :src="getMatchImg('beans')" alt="coin" width="24" height="24" />
              <span>≈&nbsp;{{ `${currencyCode} ${handleCentsToDollars(currencyAmount)}` }}</span>
            </div>
          </div>
          <div class="right">
            <div class="date">
              <img src="@/assets/packageAssets/views/P2_Page/SevenKeepSignin/default/clock.webp" alt="coin" width="16" height="16" />
              <span>{{ handleFormatCountdown }}</span>
            </div>
            <div class="withdraw" @click="goToWithdrawal">
              <!-- 判断语言 -->
              <img
                v-if="$i18n.locale == 'pt'"
                src="@/assets/packageAssets/views/P2_Page/SevenKeepSignin/default/withdraw-pt.webp"
                alt="image"
                width="20"
                height="20"
              />
              <img v-else src="@/assets/packageAssets/views/P2_Page/SevenKeepSignin/default/withdraw.webp" alt="image" width="16" height="16" />
              <span>{{ $t('lang.BaseCommon.k096') }}</span>
            </div>
          </div>
        </div>
        <div class="gift-wrapper">
          <!-- 礼物标题 -->
          <div class="gift-title">
            <img src="@/assets/packageAssets/views/P2_Page/SevenKeepSignin/default//star.webp" alt="star" width="24" height="24" />
            <span class="title">{{ $t('lang.SevenKeepSignin.k011') }}</span>
            <img src="@/assets/packageAssets/views/P2_Page/SevenKeepSignin/default/star.webp" alt="star" width="24" height="24" />
          </div>
          <!-- 礼物卡片 -->
          <div class="gift-card">
            <template v-if="!listLoading">
              <div v-for="item in rewardsList" :key="item.day" class="card-wrapper">
                <div :class="['card', item.ifCurDay ? 'now-card' : 'disable-card']">
                  <div class="title">{{ `${$t('lang.BaseCommon.k093')} ${item.index}` }}</div>
                  <div class="content">
                    <span>{{ ((item.rewardDataList || [])[0] || {}).rewardPropNumber || '-' }}</span>
                    <img :src="getMatchImg('beans')" alt="image" width="20" height="20" />
                  </div>
                </div>
                <!-- 角标 -->
                <div class="badge">
                  <!-- 已签到过 -->
                  <template v-if="item.ifSigned">
                    <img src="@/assets/packageAssets/views/P2_Page/SevenKeepSignin/default/on-check.webp" width="22" height="22" alt="image" />
                  </template>
                  <!-- 没签到过 -->
                  <template v-else-if="item.index <= currentDay">
                    <img src="@/assets/packageAssets/views/P2_Page/SevenKeepSignin/default/off-check.webp" width="22" height="22" alt="image" />
                  </template>
                  <!-- 还没到日期 -->
                  <template v-else></template>
                </div>
              </div>
              <!-- 最终奖励 -->
              <div v-if="rewardsList.length > 0" class="card-wrapper">
                <div :class="['card', 'final-card']">
                  <div class="final-image">
                    <img src="@/assets/packageAssets/views/P2_Page/SevenKeepSignin/default/treasure-box.webp" alt="image" width="36" height="23" />
                  </div>
                  <div class="content">
                    <span>{{ ((fullSignRewardConfig.rewardDataList || [])[0] || {}).rewardPropNumber || '-' }}</span>
                    <img :src="getMatchImg('beans')" alt="image" width="20" height="20" />
                  </div>
                </div>
                <!-- 角标 -->
                <div class="badge">
                  <img
                    v-if="!ifFullSign"
                    src="@/assets/packageAssets/views/P2_Page/SevenKeepSignin/default/lock.webp"
                    width="20"
                    height="20"
                    alt="image"
                  />
                  <img v-else src="@/assets/packageAssets/views/P2_Page/SevenKeepSignin/default/on-check.webp" width="20" height="20" alt="image" />
                </div>
              </div>
            </template>
            <template v-else>
              <div class="loading-wrapper">
                <van-loading />
              </div>
            </template>
          </div>
          <!-- 提示 -->
          <div class="tips">{{ $t('lang.SevenKeepSignin.k013') }}</div>
        </div>
      </div>
    </div>
    <!-- 更多标题 -->
    <div class="more-title">
      <div class="gift-title">
        <img src="@/assets/packageAssets/views/P2_Page/SevenKeepSignin/default//star.webp" alt="star" width="24" height="24" />
        <span class="title">{{ $t('lang.SevenKeepSignin.k001') }}</span>
        <img src="@/assets/packageAssets/views/P2_Page/SevenKeepSignin/default/star.webp" alt="star" width="24" height="24" />
      </div>
      <div class="tips">{{ $t('lang.SevenKeepSignin.k017') }}</div>
    </div>
    <!-- 更多内容 -->
    <div class="more-wrapper">
      <div class="item" @click="goToInvite">
        <img src="@/assets/packageAssets/views/P2_Page/SevenKeepSignin/default/inviting-friends.webp" alt="image" width="40" height="40" />
        <div class="title">{{ $t('lang.SevenKeepSignin.k002') }}</div>
        <img class="item-row-arrow" src="@/assets/packageAssets/views/P2_Page/SevenKeepSignin/default/arrow.webp" alt="" width="30" height="30" />
      </div>
      <div class="item" @click="goToDaily">
        <img src="@/assets/packageAssets/views/P2_Page/SevenKeepSignin/default/daily-task.webp" alt="image" width="40" height="40" />
        <div class="title">{{ $t('lang.BaseCommon.k094') }}</div>
        <img class="item-row-arrow" src="@/assets/packageAssets/views/P2_Page/SevenKeepSignin/default/arrow.webp" alt="" width="30" height="30" />
      </div>
      <div class="item" @click="goToCall">
        <img src="@/assets/packageAssets/views/P2_Page/SevenKeepSignin/default/match-call.webp" alt="image" width="40" height="40" />
        <div class="title">{{ $t('lang.BaseCommon.k095') }}</div>
        <img class="item-row-arrow" src="@/assets/packageAssets/views/P2_Page/SevenKeepSignin/default/arrow.webp" alt="" width="30" height="30" />
      </div>
      <div class="item" @click="goToChat">
        <img src="@/assets/packageAssets/views/P2_Page/SevenKeepSignin/default/chat.webp" alt="image" width="40" height="40" />
        <div class="title">{{ $t('lang.SevenKeepSignin.k003') }}</div>
        <img class="item-row-arrow" src="@/assets/packageAssets/views/P2_Page/SevenKeepSignin/default/arrow.webp" alt="" width="30" height="30" />
      </div>
    </div>
    <!-- WhatApp -->
    <div class="footer">
      <div class="whatapp" @click="goToWhatapp">
        <img src="@/assets/packageAssets/views/P2_Page/SevenKeepSignin/default/whatapp.webp" alt="coin" width="24" height="24" />
        <span>WhatApp</span>
      </div>
      <div class="whatapp-text">{{ $t('lang.SevenKeepSignin.k018') }}</div>
    </div>
    <!-- 弹窗 -->
    <van-dialog v-model="popupVisible" title="" :showConfirmButton="false" :showCancelButton="false" className="van-dia-class">
      <div class="dialog-wrapper" :style="cssVars()">
        <div class="header">{{ $t('lang.SevenKeepSignin.k011') }}</div>
        <div class="content">
          <div class="amount">
            <span>{{ rewardsInfo.rewardBeanNum || '-' }}</span>
            <img :src="getMatchImg('beans')" alt="coin" width="48" height="48" />
          </div>
        </div>
        <div class="button" @click="handleClosePopup">OK</div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { apiSigninList, apiSubmitSignin } from '@/api/imee.js'
import scrollMixin from '@/hooks/scroll.mixin.js'
import { getBaseFeature } from '@/assets/style/variable'

export default {
  name: 'SevenKeepSignin',
  mixins: [scrollMixin],
  data() {
    return {
      listLoading: true,
      submitDisable: false,
      submitLoading: false,
      rewardsList: [],
      popupVisible: false,
      rewardsInfo: {}, // 签到成功弹窗的信息
      timeStampTimer: null,
      expireTimeStamp: 0, // 倒计时剩余秒数
      currencyCode: '$', // 货币符号代码
      beansAmount: 0, // 我的豆子余额
      currencyAmount: 0, // 豆子等于多少钱, 单位：分
      fullSignRewardConfig: {}, // 最终签到内容
      ifFullSign: false, // 是否全部签满
      currentDay: 1, // 当前第几天
    }
  },
  created() {
    this.loadGoogleFont('Lato', [300, 400, 700])
  },
  mounted() {
    this.handleSubmitSignin(true)
  },
  computed: {
    /**
     * @description 时间戳格式转换
     */
    handleFormatCountdown() {
      let seconds = this.expireTimeStamp || 0
      if (!seconds || seconds <= 0) {
        return '00:00:00'
      }
      const days = Math.floor(seconds / (3600 * 24))
      const hours = Math.floor((seconds % (3600 * 24)) / 3600)
      const minutes = Math.floor((seconds % 3600) / 60)
      seconds = seconds % 60

      if (days > 0 || hours > 24) {
        // 大于24小时的情况
        return `${days}d ${hours}h ${minutes}m`
      } else {
        // 小于等于24小时的情况
        const hh = String(hours).padStart(2, '0')
        const mm = String(minutes).padStart(2, '0')
        const ss = String(seconds).padStart(2, '0')
        return `${hh}:${mm}:${ss}`
      }
    },
  },
  methods: {
    cssVars() {
      return { ...getBaseFeature() }
    },
    /**
     * @description 获取签到列表
     */
    async handleGetList() {
      try {
        this.listLoading = true
        const res = await apiSigninList()
        if (res && res.rewardCfgList) {
          // 赋值倒计时
          this.expireTimeStamp = this.handleCalculateSecondsDifference(res.expireTimeStamp)
          if (this.expireTimeStamp > 0) {
            this.handleStartCountdown()
          }
          // 赋值列表
          this.rewardsList = res.rewardCfgList || []

          this.rewardsList.forEach((item) => {
            if (item.ifCurDay && item.ifSigned) {
              this.submitDisable = true
            }
            if (item.ifCurDay) {
              this.currentDay = item.index
            }
          })
          // 赋值货币符号
          this.currencyCode = res.currencyCode || '$'
          // 赋值豆子余额
          this.beansAmount = res.beansAmount || 0
          // 赋值豆子等价的钱数
          this.currencyAmount = res.currencyAmount || 0
          // 赋值最终奖励
          this.fullSignRewardConfig = res.fullSignRewardConfig || {}
          this.ifFullSign = res.ifFullSign || false
        } else {
          this.$client.showToast(this.$t('lang.BaseCommon.k009'))
          console.error('获取签到列表错误！')
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.listLoading = false
      }
    },
    /**
     * @description 前往【邀请好友】页面
     */
    goToInvite() {
      this.$router.replace({
        path: '/invite',
      })
    },
    /**
     * @description 前往【任务】页面
     */
    goToDaily() {
      this.appAction('open_task_page')
    },
    /**
     * @description 前往【Match】页面
     */
    goToCall() {
      this.appAction('open_match_page')
    },
    /**
     * @description 前往【IM聊天】列表页面
     */
    goToChat() {
      this.appAction('open_session_page')
    },
    /**
     * @description 前往【规则】页面
     */
    goToRules() {
      this.$router.push({
        path: '/seven-keep-signin-rules',
        query: {
          fromPage: 'seven-keep-signin',
        },
      })
    },
    /**
     * @description 前往【提现】页面
     */
    goToWithdrawal() {
      this.$router.push({
        path: '/withdrawal',
      })
    },
    /**
     * @description 前往 WhatApp
     */
    goToWhatapp() {
      const link = 'https://whatsapp.com/channel/0029VbB5Kme9Bb5wCFm85T0A'
      this.appAction('open_web_outside', `?url=${link}`)
    },
    /**
     * @description 签到提示弹窗
     */
    handleSigninTips() {
      this.popupVisible = true
    },
    /**
     * @description 提交签到
     */
    async handleSubmitSignin(isAuto) {
      // 如果加载中
      if (this.submitLoading) return
      // 如果倒计时归零了
      if (this.rewardsList.length > 0 && this.expireTimeStamp === 0) {
        this.$client.showToast(this.$t('lang.SevenKeepSignin.k012'))
        return
      }
      // 是否禁用
      if (this.submitDisable) return
      try {
        this.submitLoading = true
        const res = await apiSubmitSignin()
        if (res && (res || {}).day) {
          this.rewardsInfo = res
          this.handleSigninTips()
        } else {
          if (!isAuto) {
            this.$client.showToast(this.$t('lang.BaseCommon.k009'))
          }
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.submitLoading = false
        // 签到后拉一次礼物列表
        setTimeout(() => {
          this.handleGetList()
        }, 1000)
      }
    },
    /**
     * @description 关闭弹窗
     */
    handleClosePopup() {
      this.popupVisible = false
    },
    /**
     * @description 计算剩余秒数
     */
    handleCalculateSecondsDifference(timestamp) {
      const currentTime = Date.now() // 获取当前时间的时间戳（毫秒）
      const targetTime = timestamp // 目标时间的时间戳（毫秒）
      // 计算差异（毫秒），然后转换为秒
      const differenceInSeconds = Math.floor((targetTime - currentTime) / 1000)
      // 如果差异是负数，说明目标时间在当前时间之前
      if (differenceInSeconds < 0) {
        return 0 // 或者可以根据需求处理这种情况
      }
      return differenceInSeconds
    },
    /**
     * @description 倒计数
     */
    handleStartCountdown() {
      if (this.timeStampTimer) {
        clearInterval(this.timeStampTimer)
      }
      const duration = 1000
      this.timeStampTimer = setInterval(() => {
        this.expireTimeStamp--
        if (this.expireTimeStamp <= 0) {
          clearInterval(this.timeStampTimer)
          this.expireTimeStamp = 0
        }
      }, duration)
    },
    /**
     * @description 美分转美元
     */
    handleCentsToDollars(centsString) {
      const cents = Number(centsString)
      if (isNaN(cents)) {
        return centsString
      }
      return (cents / 100).toFixed(2)
    },
    /**
     * @description 加载Google字体
     */
    loadGoogleFont(fontFamily, weights) {
      // 创建一个新的 <link> 元素
      const linkElement = document.createElement('link')
      // 设置 link 元素的属性
      linkElement.rel = 'stylesheet'
      linkElement.href = `https://fonts.googleapis.com/css2?family=${fontFamily.replace(/\s/g, '+')}:wght@${weights.join(';')}&display=swap`
      // 将新的 <link> 元素添加到文档头部
      document.head.appendChild(linkElement)
    },
  },
}
</script>

<style lang="scss" scoped>
.sign-in-container {
  position: relative;
  width: 100%;
  height: fit-content;
  min-height: 100vh;
  background: #6212d6 url('~@/assets/packageAssets/views/P2_Page/SevenKeepSignin/default/bg.webp') top center / contain no-repeat;
  color: #fff;
  font-weight: var(--fw-400);
  font-family: var(--string-font), sans-serif;

  // --- .custom-nav-block > van-nav-bar（未滚动顶图 / 滚动后纯色，参考 Eid 活动页 nav-default · nav-scrolling）---
  .custom-nav-block {
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
    width: 100%;
    box-sizing: border-box;
    &.nav-default {
      background: #6212d6 url('~@/assets/packageAssets/views/P2_Page/SevenKeepSignin/default/bg.webp') top center / 100% auto no-repeat;
    }
    &.nav-scrolling {
      background-color: #6212d6;
      background-image: none;
    }
    .van-bar {
      ::v-deep .van-nav-bar__left .tit-left {
        color: #ffffff;
      }
    }
  }

  // --- .rules ---
  .rules {
    position: absolute;
    top: 200px;
    right: 0;
    width: fit-content;
    height: 28px;
    border-radius: 14px 0px 0px 14px;
    opacity: 0.9;
    background: #ffffff;
    font-weight: var(--fw-700);
    font-size: var(--fs-14);
    font-family: var(--string-font);
    color: #4b2d91;
    line-height: var(--lh-headline-28);
    font-style: normal;
    padding: 0px 6px 0px 14px;
  }

  // --- .sign-in-header ---
  .sign-in-header {
    width: 95%;
    height: fit-content;
    margin: 0 auto;
    font-weight: var(--fw-400);
    font-size: var(--fs-28);
    line-height: var(--lh-headline-32);
    text-align: center;
    word-break: break-all;
    padding-top: 167px;
    padding-bottom: 16px;
    color: #ffffff;
    letter-spacing: 1px;
    text-shadow: 0px 0px 4px rgba(255, 255, 255, 0.5);
    font-family: var(--string-font);
    .dollar-amount {
      font-size: var(--fs-40);
      color: #ffe700;
      line-height: var(--lh-display-40);
      letter-spacing: 1px;
      text-shadow: 0px 0px 4px rgba(255, 255, 255, 0.5);
      font-style: italic;
      margin: 0px 6px;
      font-weight: var(--fw-700);
    }
  }

  // --- .sign-in-wrapper > .sign-in-box ---
  .sign-in-wrapper {
    width: 100%;
    height: fit-content;
    padding: 0px 16px;
    .sign-in-box {
      width: 100%;
      height: fit-content;
      background-color: #fff;
      border-radius: 16px;
      background-image: url('~@/assets/packageAssets/views/P2_Page/SevenKeepSignin/default/box-bg.webp');
      background-position: top center;
      background-size: cover;
      background-repeat: no-repeat;

      // --- .header-wrapper > .left | .right ---
      .header-wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        height: 74px;
        padding: 0px 14px;
        .left {
          width: fit-content;
          height: 100%;
          .total {
            font-weight: var(--fw-900);
            font-size: var(--fs-16);
            font-family: var(--string-font);
            color: #ffffff;
            line-height: var(--lh-title-20);
            text-align: left;
            font-style: normal;
            margin-top: 14px;
            margin-bottom: 7px;
          }
          .coin-wrapper {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            width: fit-content;
            height: 24px;
            font-weight: var(--fw-700);
            font-size: var(--fs-16);
            font-family: var(--number-font);
            color: #ffffff;
            line-height: var(--lh-title-20);
            text-align: left;
            font-style: normal;
          }
        }
        .right {
          display: flex;
          align-items: flex-end;
          justify-content: center;
          flex-direction: column;
          width: fit-content;
          height: 100%;
          .date {
            display: flex;
            align-items: center;
            justify-content: center;
            width: fit-content;
            height: 16px;
            font-weight: var(--fw-700);
            font-size: var(--fs-12);
            font-family: var(--number-font);
            color: #ffffff;
            line-height: var(--lh-label-14);
            text-align: center;
            font-style: normal;
            margin-top: 8px;
          }
          .withdraw {
            display: flex;
            align-items: center;
            justify-content: center;
            width: fit-content;
            height: 28px;
            border-radius: 14px;
            overflow: hidden;
            padding: 0px 12px;
            background-color: #ffffff;
            font-weight: var(--fw-700);
            font-size: var(--fs-12);
            font-family: var(--string-font);
            color: #9730f1;
            font-style: normal;
            line-height: var(--lh-headline-28);
            margin: 10px 0px 12px 0px;
            span {
              margin-left: 6px;
            }
          }
        }
      }

      // --- .gift-wrapper > .gift-title | .gift-card | .tips ---
      .gift-wrapper {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-direction: column;
        width: 100%;
        height: fit-content;
        min-height: 286px;
        border-radius: 16px;
        background-color: #fff;
        .gift-title {
          display: flex;
          align-items: center;
          justify-content: center;
          width: fit-content;
          height: 56px;
          .title {
            font-weight: var(--fw-700);
            font-size: var(--fs-16);
            font-family: var(--string-font);
            color: #4b2d91;
            font-style: normal;
            line-height: var(--lh-title-24);
            margin: 0px 12px;
          }
        }
        .gift-card {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          flex-wrap: wrap;
          width: 100%;
          height: fit-content;
          min-height: 178px;
          padding: 0px 12px 0px 12px;
          .card-wrapper {
            position: relative;
            width: calc((100% - 30px) / 4);
            height: 80px;
            .card {
              width: 100%;
              height: 100%;
              background: #f6eefe;
              border-radius: 5px;
              overflow: hidden;
              color: #4b2d91;
              .title {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 100%;
                height: 15px;
                font-weight: var(--fw-700);
                font-size: var(--fs-12);
                font-family: var(--string-font);
                line-height: var(--lh-label-14);
                font-style: normal;
                margin-top: 8px;
                margin-bottom: 16px;
              }
              .final-image {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 100%;
                height: fit-content;
                margin-top: 8px;
                margin-bottom: 8px;
              }
              .content {
                display: flex;
                align-items: center;
                justify-content: center;
                column-gap: 2px;
                width: 100%;
                height: 20px;
                font-weight: var(--fw-700);
                font-size: var(--fs-14);
                font-family: var(--number-font);
                line-height: var(--lh-label-16);
                font-style: normal;
              }
            }
            .disable-card {
              pointer-events: none;
              user-select: none;
              cursor: not-allowed;
            }
            .now-card {
              background: linear-gradient(180deg, #ca79ff 0%, #9e4dff 100%, #9b51ff 100%) !important;
              color: #ffffff !important;
            }
            .final-card {
              background: linear-gradient(180deg, #fff2d4 0%, #f6cb86 100%) !important;
            }
            .badge {
              position: absolute;
              z-index: 1;
              top: -6px;
              right: -6px;
            }
          }
          .card-wrapper:nth-child(1) {
            margin-right: 10px;
            margin-bottom: 16px;
          }
          .card-wrapper:nth-child(2) {
            margin-right: 10px;
            margin-bottom: 16px;
          }
          .card-wrapper:nth-child(3) {
            margin-right: 10px;
            margin-bottom: 16px;
          }
          .card-wrapper:nth-child(4) {
            margin-bottom: 16px;
          }
          .card-wrapper:nth-child(5) {
            margin-right: 10px;
          }
          .card-wrapper:nth-child(6) {
            margin-right: 10px;
          }
          .card-wrapper:nth-child(7) {
            margin-right: 10px;
          }
          .loading-wrapper {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;
          }
        }
        .tips {
          width: 100%;
          height: fit-content;
          font-weight: var(--fw-400);
          font-size: var(--fs-14);
          font-family: var(--string-font);
          color: #4b2d91;
          line-height: var(--lh-label-16);
          text-align: center;
          font-style: normal;
          text-wrap: wrap;
          padding: 16px 12px 20px 12px;
        }
      }
    }
  }

  // --- .more-title > .gift-title | .tips ---
  .more-title {
    width: 100%;
    height: fit-content;
    padding: 28px 0px;
    .gift-title {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 24px;
      .title {
        font-weight: var(--fw-700);
        font-size: var(--fs-20);
        font-family: var(--string-font);
        color: #ffffff;
        line-height: var(--lh-title-20);
        font-style: normal;
        margin: 0px 12px;
      }
    }
    .tips {
      width: 100%;
      padding: 12px 24px 0px 24px;
      font-weight: var(--fw-400);
      font-size: var(--fs-14);
      font-family: var(--string-font);
      color: #ffffff;
      line-height: var(--lh-body-20);
      text-align: center;
      font-style: normal;
      text-wrap: wrap;
    }
  }

  // --- .more-wrapper > .item ---
  .more-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    height: fit-content;
    padding: 0px 24px 26px 24px;
    .item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: 64px;
      border-radius: 8px;
      overflow: hidden;
      background: linear-gradient(45deg, #7645ff 0%, #9e4dff 100%, #9e4dff 100%, #9e4dff 100%);
      margin-bottom: 16px;
      padding: 0px 22px 0px 16px;
      font-weight: var(--fw-400);
      font-size: var(--fs-20);
      font-family: var(--string-font);
      color: #ffffff;
      line-height: var(--lh-title-24);
      font-style: italic;
      .title {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        height: 100%;
        padding: 0 10px;
      }
    }
  }

  // --- .footer > .whatapp | .whatapp-text ---
  .footer {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    height: fit-content;
    padding-bottom: 61px;
    .whatapp {
      display: flex;
      align-items: center;
      justify-content: center;
      column-gap: 12px;
      width: 149px;
      height: 44px;
      border-radius: 22px;
      overflow: hidden;
      border: 1px solid #ffffff;
      font-weight: var(--fw-700);
      font-size: var(--fs-16);
      font-family: var(--string-font);
      color: #ffffff;
      line-height: var(--lh-title-20);
      font-style: normal;
      margin-bottom: 16px;
    }
    .whatapp-text {
      font-weight: var(--fw-700);
      font-size: var(--fs-14);
      font-family: var(--string-font);
      color: #ffffff;
      line-height: var(--lh-body-20);
      text-align: left;
      font-style: normal;
    }
  }
}

// --- van-dialog 插槽（可能挂载在 body 外，不嵌套在 .sign-in-container 下）---
.dialog-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  width: 311px;
  height: 276px;
  background-color: #fff;
  border-radius: 16px;
  overflow: hidden;
  font-weight: var(--fw-400);
  font-family: var(--string-font), sans-serif;
  .header {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 64px;
    background-image: url('~@/assets/packageAssets/views/P2_Page/SevenKeepSignin/default/popup.webp');
    background-position: top center;
    background-size: contain;
    background-repeat: no-repeat;
    font-weight: var(--fw-900);
    font-size: var(--fs-24);
    font-family: var(--string-font);
    color: #ffffff;
    text-align: center;
    font-style: normal;
    line-height: var(--lh-headline-28);
  }
  .content {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    height: 140px;
    .amount {
      display: flex;
      align-items: center;
      justify-content: center;
      column-gap: 10px;
      width: fit-content;
      height: 60px;
      font-weight: var(--fw-700);
      font-size: var(--fs-40);
      font-family: var(--number-font);
      color: #4b2d91;
      line-height: var(--lh-display-40);
      font-style: normal;
    }
  }
  .button {
    width: 250px;
    height: 52px;
    background-color: #8741e8;
    border-radius: 26px;
    overflow: hidden;
    font-weight: var(--fw-700);
    font-size: var(--fs-20);
    font-family: var(--string-font);
    color: #ffffff;
    line-height: var(--lh-display-48);
    font-style: normal;
    text-align: center;
  }
}

::v-deep .van-dia-class {
  width: 311px;
}

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .sign-in-container {
    .custom-nav-block .left-nav {
      transform: rotateY(180deg);
    }

    .more-wrapper .item-row-arrow {
      transform: rotateY(180deg);
    }
  }
}
</style>
